import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Field} from '../../../model/field.model';
import {Tree} from '../../../model/tree.model';
import {Line} from '../../../model/line.model';
import {StateService} from '../../../state.service';
import {calculateYearlyYield, inferStartYear, YearlyYield} from '../../../utils/yield.utils';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-tree',
    templateUrl: './tree.component.html',
    styleUrls: ['./tree.component.css'],
    standalone: false
})
export class TreeComponent implements OnInit {
  @ViewChild('deleteConfirmDialog') deleteConfirmDialog!: TemplateRef<any>;
  field: Field;
  tree: Tree;
  line: Line;
  totalWeightPerTree: number;
  avgTrufflePerTree: number;
  bonus: number;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService,
              private dialog: MatDialog) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.stateService.getField(params.get('fieldId')).subscribe(f => {
        this.field = f;
        this.field.lines.forEach(l => {
          if (l.id === +params.get('lineId')) {
            this.line = l;
          }
        });
        if (this.line.trees.length > 0) {
          const treeIdParam = params.get('treeId');
          this.tree = treeIdParam ? this.line.trees[+treeIdParam - 1] : this.line.trees[0];
          this.totalWeightPerTree = this.getTotalWeightPerTree();
          this.avgTrufflePerTree = this.getAvgTrufflePerTree();
          this.bonus = this.getBonus();
        }
      });
    });
  }

  goLeft() {
    this.router.navigate( ['field/' + this.field.id + '/line/' + this.line.id + '/tree/' + this.line.trees[+this.tree.id - 2].id]);
  }

  goRight() {
    this.router.navigate( ['field/' + this.field. id + '/line/' + this.line.id + '/tree/' + this.line.trees[+this.tree.id].id]);
  }

  deleteTree(tree: Tree) {
    if (tree.truffleFounds && tree.truffleFounds.length > 0) {
      alert('Baum kann nicht gelöscht wenn schon Trüffel gefunden wurden');
      return;
    }

    const dialogRef = this.dialog.open(this.deleteConfirmDialog, {autoFocus: false});
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'confirm') {
        this.removeTree(tree);
      }
    });
  }

  addTree() {
    this.stateService.field = this.field;
    this.stateService.line = this.line;
    this.router.navigate( ['addTree']);
  }

  addTruffle() {
    this.stateService.field = this.field;
    this.stateService.line = this.line;
    this.stateService.tree = this.tree;
    this.router.navigate( ['/addTruffle']);
  }

  goToTruffle() {
    this.stateService.field = this.field;
    this.stateService.line = this.line;
    this.stateService.tree = this.tree;
    this.router.navigate( ['field/' + this.field.id + '/line/' + this.line.id + '/tree/' + this.tree.id + '/truffle']);
  }

  editTree(tree: Tree) {
    this.stateService.field = this.field;
    this.stateService.line = this.line;
    this.stateService.tree = tree;
    this.router.navigate( ['editTree']);
  }

  getTotalWeightPerTree() {
    if (!this.tree || !this.tree.truffleFounds) {
      return 0;
    }
    let totalTruffel = 0;
    this.tree.truffleFounds.forEach(f => {
      if (f.weight) {
        totalTruffel += f.weight;
      }
    });
    return totalTruffel;
  }

  getAvgTrufflePerTree() {
    let totalTruffleFound = 0;
    let totalTees = 0;
    this.field.lines.forEach(line => {
      totalTees += line.trees.length;
      line.trees.forEach(tree => {
        tree.truffleFounds.forEach(found => {
          totalTruffleFound += found.weight;
        });
      });
    });
    return totalTruffleFound / totalTees;
  }

  getBonus() {
    if (this.avgTrufflePerTree > this.totalWeightPerTree) {
      return -10;
    } else if (this.avgTrufflePerTree < this.totalWeightPerTree) {
      return 10;
    } else {
      return 0;
    }
  }

  getUserAmount() {
    return this.avgTrufflePerTree * this.bonus / 100 + this.avgTrufflePerTree;
  }

  getYearlyYieldForTree(tree: Tree): YearlyYield[] {
    const startYear = inferStartYear(tree.createdAt, undefined, tree.truffleFounds);
    return calculateYearlyYield(tree.truffleFounds, startYear);
  }

  private removeTree(tree: Tree) {
    const index: number = this.field.lines[this.line.id - 1].trees.indexOf(tree);
    if (index !== -1) {
      this.field.lines[this.line.id - 1].trees.splice(index, 1);
      this.stateService.deleteTree(this.field);
      const lastTree = this.line.trees[this.line.trees.length - 1];
      if (lastTree) {
        this.tree = lastTree;
        this.router.navigate(['field/' + this.field.id + '/line/' + this.line.id + '/tree/' + lastTree.id]);
      } else {
        this.tree = undefined;
        this.router.navigate(['field/' + this.field.id + '/line/' + this.line.id]);
      }
    }
  }
}
